import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import { DocumentRequirement } from '../DocumentRequirement/DocumentRequirement';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const ManagementAccounts = ({
  isOptional,
  isSubmitted,
  status,
}: TProps) => {
  return (
    <DocumentRequirement
      title="Current management accounts"
      documentType="management accounts"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>
        These could be whatever the business uses to aid forecasting, spending
        and budgeting.
      </p>
    </DocumentRequirement>
  );
};
